import { Region } from '@/services/auth/types';
import { getAppVersion } from '@/utils/version';
import { isEmptyString } from '@/utils/string';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { ACTIVE_SESSION_HEADER, activeSessionIdStore } from '@customerio/hydra-session-state';

/**
 * @deprecated
 */
export const axiosServicesApi = axios.create({
  baseURL: '/v1',
  withCredentials: true,
});

export function setServicesApiRegion(region: Region) {
  if (__CIO_ENV__ !== 'production' && __CIO_ENV__ !== 'standalone') {
    return;
  }

  let regionUrlMap = {
    [Region.US]: '',
    [Region.EU]: '',
  };

  if (__CIO_ENV__ === 'production') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly.customer.io',
      [Region.EU]: 'https://eu.fly.customer.io',
    };
  } else if (__CIO_ENV__ === 'standalone') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly-standalone.customer.io',
      [Region.EU]: 'https://us.fly-standalone.customer.io',
    };
  }

  axiosServicesApi.defaults.baseURL = `${regionUrlMap[region]}/v1`;
}

// Default to US for auth and calls made before an account is known
setServicesApiRegion(Region.US);

for (const api of [axiosServicesApi]) {
  api.interceptors.request.use(async (config) => {
    const cookies = new Cookies();
    const accessToken = cookies.get('_access');

    if (!isEmptyString(accessToken)) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers[ACTIVE_SESSION_HEADER] = activeSessionIdStore.get().toString();
    config.headers['x-ui-version'] = getAppVersion();

    return config;
  });
}
